import { AxiosResponse } from "axios";
import { TypeFornecedor } from "../../Models/Pessoa/Fornecedor";
import { Axios } from "../Axios";
import { QueryBasicaParam } from "../../Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";

export class FornecedorService {
    public listar(fornecedor: TypeFornecedor): Promise<AxiosResponse<TypeFornecedor[]>> {
        return Axios.post<TypeFornecedor[]>(`Fornecedor/listar`, fornecedor);
    }

    public inserir(fornecedor: TypeFornecedor){
        return Axios.post('Fornecedor/inserir', fornecedor);
    }

    public atualizar(fornecedor: TypeFornecedor){
        return Axios.put('Fornecedor/atualizar', fornecedor);
    }

    public ativar(codigoDoFornecedor: number){
        return Axios.patch(`Fornecedor/ativar/${codigoDoFornecedor}`);
    }

    public desativar(codigoDoFornecedor: number){
        return Axios.patch(`Fornecedor/desativar/${codigoDoFornecedor}`);
    }

}

export function useFornecedorListar({
    fornecedor,
    onFinish,
    ...rest
}:QueryBasicaParam<AxiosResponse<TypeFornecedor[]>, TypeFornecedor[], {
    fornecedor : TypeFornecedor,
    onFinish?: () => void
}>) {
    return useQuery({
        ...rest,
        queryKey: ["Pessoa", "Fornecedor", "ListarTodos", "Parametros"],
        queryFn: () => Axios.post<TypeFornecedor[]>(`Fornecedor/listar`, fornecedor).finally(onFinish),
        select(data) {
            return data.data;
        },
        staleTime : 1000 * 60 * 0.1
    })
}